import { validateProps } from '../../utils/PropsValidationUtils';
import { isValidBase } from '../BaseEntity';
export let DigestType = /*#__PURE__*/function (DigestType) {
  DigestType["UNKNOWN_DIGEST_TYPE"] = "UNKNOWN_DIGEST_TYPE";
  DigestType["TASK"] = "TASK";
  DigestType["ROUTINE"] = "ROUTINE";
  DigestType["CATEGORY"] = "CATEGORY";
  return DigestType;
}({});
export function isValidDigest(digest) {
  return isValidBase(digest) && validateProps(digest, ['type', 'data']);
}
//# sourceMappingURL=Digest.js.map